import {fabric} from 'fabric'
export function makeTextBox(canvas) {
    canvas.on('mouse:down', function(options) {
            if((options.target == null) || (options.target.type === 'image') ){
            addText(options.e);
            }
        
    });

    function addText(e) {
        const text = new fabric.Textbox('',{
            left: e.offsetX,
            top: e.offsetY,
            fontSize: 12,
            color:"black",
            fontFamily:"Verdana",
            backgroundColor:"aliceblue"
        });

        canvas.add(text);
        canvas.bringToFront(text);
        text.enterEditing();
    }


}
